import React, { useContext } from 'react';

import { OnChangeGlobalContext, IOnChangeGlobalContext } from '../GlobalContext';
import { Meta } from '../Meta';

const NewBuildingQuizPageSeo = () => {
    const onChangeGlobalContext = useContext<IOnChangeGlobalContext>(OnChangeGlobalContext);
    const canonicalUrl = onChangeGlobalContext.linkBuilder.quiz({});

    return (
        <Meta
            title='Персональный подбор новостройки'
            description='Пройдите короткий тест, и мы подберём подходящую под ваши условия новостройку'
            canonical={canonicalUrl}
        />
    );
};

NewBuildingQuizPageSeo.displayName = 'NewBuildingQuizPageSeo';

export default NewBuildingQuizPageSeo;
